module.exports = __webpack_public_path__ + "img/s03_p02-big.e4076592.png";